export const generateObjectId = () => {
  const timestamp = Math.floor(Date.now() / 1000).toString(16); // 4 bytes (8 hex chars)

  const randomHex = () =>
    Math.floor(Math.random() * 0x1000000)
      .toString(16)
      .padStart(6, '0'); // 3 bytes (6 hex chars)

  const machine = randomHex();     // 3 bytes
  const pid = randomHex().slice(0, 4); // 2 bytes
  const counter = randomHex().slice(0, 6); // 3 bytes

  return (timestamp + machine + pid + counter).padEnd(24, '0');
};
